export default "__VITE_ASSET__DRcTs0IB__"